import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Brush,
} from "recharts";
import { Colors } from "../../../constants/colors";
import { getLineColor } from "../../../utils/getLineColor";

const NpsOverTimeScoreChart = ({ data, smoothLine }) => {
    const allScores = data.flatMap((item) =>
        item.lines.map((line) => line.score)
    );
    const rawMin = Math.min(...allScores);
    const rawMax = Math.max(...allScores);
    const minScore = Math.floor(rawMin);
    const maxScore = Math.ceil(rawMax);
    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={data}
                margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                    dataKey="label"
                    tick={{ fontSize: 14, fill: "#333", fontWeight: "500" }}
                />
                <YAxis
                    tick={{ fontSize: 14, fill: "#333" }}
                    domain={[minScore, maxScore]}
                />
                <Tooltip
                    contentStyle={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                    labelStyle={{ fontWeight: "bold" }}
                    formatter={(value) => value}
                />
                <Legend
                    wrapperStyle={{ bottom: 25 }}
                    align="center"
                    verticalAlign="bottom"
                    iconType="circle"
                />
                {data.length > 0 &&
                    data[0].lines.map((line, index) => (
                        <Line
                            key={line.lineId}
                            type={smoothLine ? "monotone" : "linear"}
                            dataKey={`lines[${index}].score`}
                            stroke={getLineColor(index)}
                            strokeWidth={3}
                            dot={false}
                            activeDot={{
                                r: 6,
                                stroke: getLineColor(index),
                                strokeWidth: 2,
                            }}
                            name={line.driver}
                        />
                    ))}
                <defs>
                    <linearGradient id="brushGreyGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#B0B0B0" stopOpacity={0.7} />
                        <stop offset="50%" stopColor="#D3D3D3" stopOpacity={0.5} />
                        <stop offset="100%" stopColor="#F5F5F5" stopOpacity={0.3} />
                    </linearGradient>
                </defs>
                <Brush
                    dataKey="label"
                    height={35}
                    stroke={Colors.gray7}
                    fill="url(#brushGreyGradient)"
                    travellerWidth={28}
                    travellerStyle={{
                        stroke: "#555",
                        fill: "#777",
                        cursor: "pointer",
                    }}
                    selectedBoxStyle={{
                        stroke: "#555",
                        fill: "rgba(175,168,168,0.3)",
                        cursor: "move",
                    }}
                    gap={1}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default NpsOverTimeScoreChart;
